import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { Wine, WinePayload, WineUploadUrlResponse } from '@shared/partner-ui/models/wine';
import { WinesApi } from '@shared/partner-ui/services/wines-api';

@Injectable({
  providedIn: 'root'
})
export class WinesService implements WinesApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/account/wines`;

  async list(_wineryId?: string): Promise<Wine[]> {
    return firstValueFrom(this.http.get<Wine[]>(this.baseUrl, { withCredentials: true }));
  }

  async create(payload: WinePayload, _wineryId?: string): Promise<Wine> {
    return firstValueFrom(
      this.http.post<Wine>(this.baseUrl, payload, { withCredentials: true })
    );
  }

  async update(id: string, payload: WinePayload, _wineryId?: string): Promise<Wine> {
    return firstValueFrom(
      this.http.put<Wine>(`${this.baseUrl}/${id}`, payload, { withCredentials: true })
    );
  }

  async getUploadUrl(
    fileName: string,
    contentType: string,
    _wineryId?: string
  ): Promise<WineUploadUrlResponse> {
    return firstValueFrom(
      this.http.post<WineUploadUrlResponse>(
        `${this.baseUrl}/upload-url`,
        { fileName, contentType },
        { withCredentials: true }
      )
    );
  }
}
